import { render, staticRenderFns } from "./jsgl.vue?vue&type=template&id=676e4c71&scoped=true"
import script from "./jsgl.vue?vue&type=script&lang=js"
export * from "./jsgl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e4c71",
  null
  
)

export default component.exports